import { Link } from "react-router-dom";
import { BedDouble, Bath, Ruler } from "lucide-react";
import { formatINR, imgSrc } from "../lib/api";

export default function PropertyCard({ property: p, index = 0 }) {
  const img = imgSrc(p.images?.[0]);
  return (
    <Link
      to={`/property/${p.id}`}
      data-testid={`property-card-${p.id}`}
      className="group block border border-white/10 bg-obsidian transition-colors duration-500 hover:border-gold/50"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {img && (
          <img
            src={img}
            alt={p.title}
            loading={index > 2 ? "lazy" : "eager"}
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/10" />
        <span className="absolute left-4 top-4 bg-black/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-gold backdrop-blur-md">
          {p.listing_type === "rent" ? "For Lease" : "For Sale"}
        </span>
        {p.featured && (
          <span className="absolute right-4 top-4 bg-gold px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-ink">
            Featured
          </span>
        )}
        <p className="absolute bottom-4 left-4 font-serif text-2xl text-bone">{formatINR(p.price, p.price_unit)}</p>
      </div>
      <div className="p-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{p.locality}</p>
        <h3 className="mt-2 font-serif text-xl leading-snug text-bone transition-colors group-hover:text-gold">{p.title}</h3>
        <div className="mt-4 flex items-center gap-5 border-t border-white/10 pt-4 text-xs font-light text-smoke">
          <span className="flex items-center gap-1.5"><BedDouble size={14} className="text-gold" />{p.beds} Beds</span>
          <span className="flex items-center gap-1.5"><Bath size={14} className="text-gold" />{p.baths} Baths</span>
          <span className="flex items-center gap-1.5"><Ruler size={14} className="text-gold" />{p.sqft?.toLocaleString("en-IN")} ft²</span>
        </div>
      </div>
    </Link>
  );
}
